module.exports = __webpack_public_path__ + "static/img/4-2.94637a83.png";